<script>
    export default {
        props: [
            'route',
            'initLang', 
            'initConfig', 
        ],
        data() {
            return {
                lang: this.initLang,                
                mainBrand: "",
                mainCountry: "",
                mainSite: "",
                mainRangeStart: "",
                mainRangeEnd: "",              
                compareBrand: "",
                compareCountry: "",
                compareSite: "",
                compareRangeStart: "",
                compareRangeEnd: "",
                widget: this.$parent.widget,
                widgetObjects: [],
                config: this.initConfig,
            }
        },
        mounted: function(){
            let dashboardWidgetFilter = this;

            dashboardWidgetFilter.lang = $.extend({}, dashboardWidgetFilter.$parent.$parent.lang, dashboardWidgetFilter.$parent.lang, dashboardWidgetFilter.lang);

            Event.$on("mainFilterChanged", function(dashboardMainFilter){
                dashboardWidgetFilter.mainBrand = dashboardMainFilter.mainBrand;
                dashboardWidgetFilter.mainCountry = dashboardMainFilter.mainCountry;
                dashboardWidgetFilter.mainSite = dashboardMainFilter.mainSite;
                dashboardWidgetFilter.mainRangeStart = dashboardMainFilter.mainRangeStart;
                dashboardWidgetFilter.mainRangeEnd = dashboardMainFilter.mainRangeEnd;
                dashboardWidgetFilter.compareBrand = dashboardMainFilter.compareBrand;
                dashboardWidgetFilter.compareCountry = dashboardMainFilter.compareCountry;
                dashboardWidgetFilter.compareSite = dashboardMainFilter.compareSite;
                dashboardWidgetFilter.compareRangeStart = dashboardMainFilter.compareRangeStart;
                dashboardWidgetFilter.compareRangeEnd = dashboardMainFilter.compareRangeEnd;
                dashboardWidgetFilter.applyWidgetFilter();
            }); 

            Event.$on("objectMounted", function(dashboardWidgetObject){
                if(dashboardWidgetFilter.widget == dashboardWidgetObject.widget){
                    dashboardWidgetFilter.widgetObjects.push(dashboardWidgetObject.$props);
                }
            });            
        },
        methods: {
            applyWidgetFilter: function () {
                let dashboardWidgetFilter = this;

                Event.$emit('widgetFilterChanged', dashboardWidgetFilter);
                
                if(dashboardWidgetFilter.widget.substring(0, 4) == 'test'){
                    /*
                    var request = {
                        widget: "test-widget-2",
                        widgetObjects: [{
                            name: "test-chart-pie",
                            type: "chart",
                            enableCompare: true,
                            initConfig: {},
                            initLang: [],
                        },{
                            name: "test-chart-line",
                            type: "chart",
                            enableCompare: true,
                            initConfig: {},
                            initLang: [],
                        }],
                        mainBrand: "Dolce Gabbana",
                        mainCountry: "Italy",
                        mainSite: "Subito.it",
                        mainRangeStart: "2018-12-01",
                        mainRangeEnd: "2018-12-31",
                        compareBrand: "Armani",
                        compareCountry: "France",
                        compareSite: "Subito.it",
                        compareRangeStart: "2018-12-01",
                        compareRangeEnd: "2018-12-31",
                        config: {} //custom object containing params passed from the front-end widget
                    };
                    */
                    var response = {
                        "test-mini-1": {
                            series: [{
                                data: 9 //main range result
                            }, {
                                data: 0 //compare range result (if enableCompare = true)
                            }],
                        },
                        "test-mini-2": {
                            goal: 2000,
                            series: [{
                                data: 108999 //main range result
                            }, {
                                data: 204434 //compare range result (if enableCompare = true)
                            }],
                        },
                        "test-mini-3": {
                            series: [{
                                data: 4005.6 //main range result
                            }, {
                                data: 2002.7 //compare range result (if enableCompare = true)
                            }],
                        },
                        "test-mini-4": {
                            series: [{
                                data: 423004453.90 //main range result
                            }, {
                                data: 23004453.90 //compare range result (if enableCompare = true)
                            }],
                        },
                        "test-mini-5": {
                            qualityLabel: "nice",
                            qualityClass: "label-success",
                            compareDeltaClass: "text-green",
                            series: [{
                                data: -700 //main range result
                            }, {
                                data: -950 //compare range result (if enableCompare = true)
                            }],
                        },
                        "test-table": {
                            series: [{
                                data: [
                                    ['Piatti', 15, 562, 80, 134, 23, 10, "http://www.digitaloverture.it/homed.html"],
                                    ['Vassoi', 29, 23, 35, 567, 13, 12, "https://www.youtube.com/embed/Ir7J0eEuWgk"],
                                    ['Ceramica', 451, 67, 50, 11, 75, -16, "https://www.youtube.com/embed/fu3645D4ZlI"],
                                ] //main range result
                            }, {
                                data: [
                                    ['Piatti', 15, 223, 45, 234, 23, -24, "http://www.digitaloverture.it/homed.html"],
                                    ['Vassoi', 43, 1, 32, 545, 2, 23, "https://www.youtube.com/embed/Ir7J0eEuWgk"],
                                    ['Ceramica', 200, 23, 89, 11, 75, -76, "https://www.youtube.com/embed/fu3645D4ZlI"],
                                ] //compare range result (if enableCompare = true)
                            }],
                        },
                        "test-sparkline-bar": {
                            valueDeltaPerc: +23.78,
                            series: [{
                                data: [9, 0, 4, 1, 0, 14, 6, 9, 0, 4, 1, 0, 14, 6, 9, 0, 4, 1, 0, 14, 6, 9, 0, 4, 1, 0, 14, 6] //main range result
                            }],
                        },
                        "test-sparkline-line-1": {
                            valueDeltaPerc: -63.50,
                            series: [{
                                data: [0, 14, 6, 9, 0, 4, 1, 0, 14, 4, 1, 0, 14, 6] //main range result
                            }],
                        },
                        "test-sparkline-line-2": {
                            valueDeltaPerc: 11,
                            series: [{
                                data: [9, 0, 4, 1, 0, 14, 6, 9, 0, 4, 1, 0, 14, 6] //main range result
                            }],
                        },
                        "test-chart-area": {
                            series: [{
                                data: [9, 0, 4, 1, 0, 14, 6] //main range result with 0 value for for empty units
                            }, {
                                data: [6, 2, 6, 11, 10, 1, 8] //compare range result with 0 value for for empty units (if enableCompare = true)
                            }],
                        },
                        "test-chart-area-custom-x": {
                            xAxis: [{
                                type: "category",
                                categories: ["cat-1", "cat-2", "cat-3", "cat-4", "cat-5", "cat-6", "cat-7"],
                                min: null,
                                max: null,
                                labels: {
                                    format: '{value}'
                                }
                            }, {
                                type: "category",
                                categories: ["cat-1", "cat-2", "cat-3", "cat-4", "cat-5", "cat-6", "cat-7"],
                                min: null,
                                max: null,
                                labels: {
                                    format: '{value}'
                                }
                            }],
                            series: [{
                                data: [9, 0, 4, 1, 0, 14, 6], //main range result with 0 value for for empty units
                                pointStart: null,
                                pointIntervalUnit: null,
                            }, {
                                data: [6, 2, 6, 11, 10, 1, 8], //compare range result with 0 value for for empty units (if enableCompare = true)
                                pointStart: null,
                                pointIntervalUnit: null,
                            }],
                        },
                        "test-chart-line": {
                            series: [{
                                data: [9, 0, 4, 1, 0, 14, 6] //main range result with 0 value for for empty units
                            }, {
                                data: [6, 2, 6, 11, 10, 1, 8] //compare range result with 0 value for for empty units (if enableCompare = true)
                            }],
                        },
                        "test-chart-column": {
                            series: [{
                                data: [9, 0, 4, 1, 0, 14, 6] //main range result with 0 value for for empty units
                            }, {
                                data: [6, 2, 6, 11, 10, 1, 8] //compare range result with 0 value for for empty units (if enableCompare = true)
                            }],
                        },
                        "test-chart-bar": {
                            series: [{
                                data: [9, 0, 4, 1, 0, 14, 6] //main range result with 0 value for for empty units
                            }, {
                                data: [6, 2, 6, 11, 10, 1, 8] //compare range result with 0 value for for empty units (if enableCompare = true)
                            }],
                        },
                        "test-chart-pie": {
                            series: [{
                                data: [{
                                    name: 'Organic',
                                    y: 6000,
                                    selected: true
                                }, {
                                    name: 'Paid',
                                    y: 100
                                }],  //main range result with 0 value for for empty units
                            },{
                                data: [],
                            }], //compare range result with 0 value for for empty units (if enableCompare = true);
                        },
                        "test-chart-solidgauge-1": {
                            valueDeltaPerc: +33.50,
                            yAxis: {
                                max: 300
                            },
                            series: [{
                                data: [60]
                            }],  
                        },
                        "test-chart-solidgauge-2": {
                            valueDeltaPerc: -110.23,
                            yAxis: {
                                max: 30000
                            },
                            series: [{
                                data: [2346]
                            }],  
                        },
                    };
                    Event.$emit('widgetFilterApplied', dashboardWidgetFilter, response);
                }else{
                    axios.post(dashboardWidgetFilter.route, {
                        widget: dashboardWidgetFilter.widget,
                        widgetObjects: dashboardWidgetFilter.widgetObjects,
                        mainBrand: dashboardWidgetFilter.mainBrand,
                        mainCountry: dashboardWidgetFilter.mainCountry,
                        mainSite: dashboardWidgetFilter.mainSite,
                        mainRangeStart: dashboardWidgetFilter.mainRangeStart,
                        mainRangeEnd: dashboardWidgetFilter.mainRangeEnd,
                        compareBrand: dashboardWidgetFilter.compareBrand,
                        compareCountry: dashboardWidgetFilter.compareCountry,
                        compareSite: dashboardWidgetFilter.compareSite,
                        compareRangeStart: dashboardWidgetFilter.compareRangeStart,
                        compareRangeEnd: dashboardWidgetFilter.compareRangeEnd,
                        config: dashboardWidgetFilter.config
                    })
                    .then((response) => {
                        Event.$emit('widgetFilterApplied', dashboardWidgetFilter, response.data);
                    })
                    .catch((err) => {
                        console.log(err);
                    });
                }

            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/admin/dashboards/dashboardWidgetFilter.vue